import React from 'react';
import { Icon } from './Icon.js';
export const IconFlag2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M13.25,2.5H4V11H13.25c.965,0,1.75-.785,1.75-1.75V4.25c0-.965-.785-1.75-1.75-1.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3.75,17c-.414,0-.75-.336-.75-.75V1.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75v14.5c0,.414-.336,.75-.75,.75Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconFlag2Fill18.js.map